import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { RegisterTicket, Ticket } from '../models/ticket';
import { Bonocliente } from '../models/bonocliente';

@Injectable({
  providedIn: 'root'
})

export class TicketService {

  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.url + 'ticket/';
  }

  getById(id: number): Observable<Ticket> {
    let urlcom = this.url + id;
    return this.http.get<Ticket>(urlcom);
  }

  save(data: RegisterTicket): Observable<Ticket> {
    let urlcom = this.url + "register";
    return this.http.post<Ticket>(urlcom, data);
  }

  update(id: number, data: RegisterTicket): Observable<Ticket> {
    let urlcom = this.url + "update/" + id;
    return this.http.put<Ticket>(urlcom, data);
  }

  delete(id: number): Observable<any> {
    let urlcom = this.url + id;

    return this.http.delete(urlcom);
  }

  getBonoclientesClienteParaTicket(idCliente: number, idTicket?: number): Observable<Bonocliente[]> {
    let urlcom = this.url + idCliente + "/bonoclientes_tk";
    if (idTicket) {
      const params = new HttpParams().set('ticketId', idTicket.toString());
      return this.http.get<Bonocliente[]>(urlcom, { params });
    }
    return this.http.get<Bonocliente[]>(urlcom);
  }

  comprobarBonoDescuento(codigoBc: string, servicioId: number): Observable<any> {
    const params = new HttpParams()
      .set('codigoBc', codigoBc)
      .set('servicioId', servicioId.toString());

    return this.http.get<any>(this.url + "comprobar_bono_descuento", { params });
  }

  getByIdParaDevolucion(id: number): Observable<Ticket> {
      let urlcom = this.url + 'devolucion/' + id;
      return this.http.get<Ticket>(urlcom);
    }

}
